// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Ijh1","alert":"SettungsInbox_alert__1h0w8"};